import React from 'react';
import styled from 'styled-components';
import { cores } from '../../../../styles/styleUtils';

const KPIContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
`;

const KPIBox = styled.div`
  background-color: ${cores.cinzaClaro};
  border: 1px solid #E2E4E8;
  border-radius: 5px;
  padding: 16px;
  text-align: center;
`;

const KPITitle = styled.h4`
  color: ${cores.cinzaMedio};
  font-size: 1rem;
  margin-bottom: 8px;
`;

const KPIData = styled.span`
  font-size: 1.5rem;
  color: ${cores.chumbo};
  font-weight: bold;
`;

const KPIButton = styled.button`
  background-color: ${cores.laranja};
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  margin-top: 10px;

  &:hover {
    background-color: ${cores.laranjaEscuro};
  }
`;

const KPISection = ({totaisReceitas, data, filtro}) => {



  return (
    <KPIContainer>
      <KPIBox>
        <KPITitle>Percentual Atingido Mês</KPITitle>
        <KPIData>{data.PercentualMetaRecebimento[new Date(filtro.datainicial).getMonth()]?.toFixed(2)}%</KPIData>
        
      </KPIBox>
      <KPIBox>
        <KPITitle>Total de Recebimentos no mês</KPITitle>
        <KPIData>{totaisReceitas.totalRecebido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</KPIData>
       
      </KPIBox>
    </KPIContainer>
  );
};

export default KPISection;